import { ChangeEvent, ReactNode, RefCallback } from 'react'
import classNames from 'classnames/bind'

import styles from './plain-checkbox.module.scss'

const cx = classNames.bind(styles)

export type Props = {
  name?: string
  value: string
  label?: string | ReactNode
  hideLabel?: boolean // скрыт, но доступен для скрин-ридеров
  skipLabel?: boolean
  checked?: boolean | null
  defaultChecked?: boolean
  id?: string
  disabled?: boolean
  className?: string
  indeterminate?: boolean
  reference?: RefCallback<HTMLInputElement>
  level?: number
  style?: Object
  form?: string
  large?: boolean

  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  onFocus?: (e: ChangeEvent<HTMLInputElement>) => void
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void
}

const PlainCheckbox = ({
  name,
  value,
  label,
  hideLabel,
  skipLabel,
  checked,
  defaultChecked,
  id,
  disabled,
  className,
  indeterminate,
  reference,
  level,
  style,
  form,
  large,

  onChange,
  onFocus,
  onBlur,
}: Props) => {
  const currentId = id || `${name || ''}_${value}`

  const levelClassName = { [`level${level || ''}`]: level }
  const rootClassName = cx(
    styles.root,
    { disabled, hideLabel, large, ...levelClassName },
    className,
  )
  const checkboxClassName = cx(styles.check, {
    disabled: disabled || indeterminate,
    skipLabel,
    hideLabel,
  })
  const labelClassName = cx(styles.label, { hidden: hideLabel, disabled })

  const containerClassName = skipLabel
    ? cx(styles.container, { skipLabel, ...levelClassName }, className)
    : cx(styles.container, { hideLabel })

  const renderControl = (
    <span className={containerClassName}>
      <input
        id={currentId}
        type="checkbox"
        name={name}
        value={value}
        checked={typeof checked === 'boolean' ? checked : undefined}
        defaultChecked={defaultChecked}
        disabled={disabled}
        className={styles.input}
        ref={reference}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        form={form}
      />

      <span className={checkboxClassName} />

      {label && !skipLabel && <span className={labelClassName}>{label}</span>}
    </span>
  )

  if (skipLabel) {
    return renderControl
  }

  return (
    <label // eslint-disable-line jsx-a11y/label-has-associated-control
      className={rootClassName}
      style={style}
    >
      {renderControl}
    </label>
  )
}

export default PlainCheckbox
